import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, ValuesInterface } from "interface/rideType";
import { StatusInterface } from "interface/common";

export const rideTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRideTypes: builder.query<ApiResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: API.GET_RIDE_TYPE,
        method: "GET",
        params,
      }),
      providesTags: ["RideType"],
    }),
    getRideTypeList: builder.query<
      ApiResponse,
      { [key: string]: string | number } | void
    >({
      query: (params) => ({
        url: API.GET_RIDE_TYPE_LIST,
        method: "GET",
        params: params || undefined,
      }),
      providesTags: ["RideType"],
    }),
    createRideType: builder.mutation<
      ApiResponse,
      { params: ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_RIDE_TYPE,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["RideType"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create ride type:", error);
        }
      },
    }),
    updateRideType: builder.mutation<
      ApiResponse,
      { params: ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_RIDE_TYPE,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["RideType"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update ride type:", error);
        }
      },
    }),
    updateRideTypeStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_RIDE_TYPE}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["RideType"],
    }),
    deleteRideType: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_RIDE_TYPE}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RideType"],
    }),
    bulkUpdateRideTypeStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_RIDE_TYPE}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["RideType"],
    }),
    bulkDeleteRideTypes: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_RIDE_TYPE}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["RideType"],
    }),
  }),
});

export const {
  useGetRideTypesQuery,
  useGetRideTypeListQuery,
  useCreateRideTypeMutation,
  useUpdateRideTypeMutation,
  useUpdateRideTypeStatusMutation,
  useDeleteRideTypeMutation,
  useBulkUpdateRideTypeStatusMutation,
  useBulkDeleteRideTypesMutation,
} = rideTypeApi;
